import { v4 } from 'uuid';
import type { ReduxNotificationLevel } from 'containers/Notifications/types';
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './constants';

// level: 'success' | 'error' | 'warning' | 'info'
// sticky: true | false
// uid: undefined | <string>
export const addNotification = (
  level: ReduxNotificationLevel,
  message: string,
  sticky = false,
  uid?: string
) => ({
  type: ADD_NOTIFICATION,
  level,
  message,
  sticky,
  uid: uid ?? v4(),
});

// Returns an action which when dispatched will remove the notification
// with the given uid.
export function removeNotification(uid: string) {
  return {
    type: REMOVE_NOTIFICATION,
    uid,
  };
}
